var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.5,
    viewBox: "0 0 14 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10682",
    "data-name": "Path 10682",
    d: "M71.95,743.9A7,7,0,1,0,61,751.986l.027.022a.5.5,0,0,0,.322.117h8.308a.5.5,0,0,0,.322-.117l.027-.022A7.009,7.009,0,0,0,71.95,743.9ZM69.4,750.938H61.6a5.813,5.813,0,1,1,7.794,0Zm-2.155-6.477a.124.124,0,0,0-.177,0l-1.32,1.32a.876.876,0,1,0,.619.619l1.32-1.32a.126.126,0,0,0,0-.177Zm-2.086-1.586h.687a.125.125,0,0,0,.125-.125V741.5a.125.125,0,0,0-.125-.125h-.687a.125.125,0,0,0-.125.125v1.249A.125.125,0,0,0,65.156,742.875Zm4.062,3.406v.688a.125.125,0,0,0,.125.125h1.25a.125.125,0,0,0,.125-.125v-.688a.125.125,0,0,0-.125-.125h-1.25A.125.125,0,0,0,69.219,746.281Zm.2-3.081-.486-.485a.125.125,0,0,0-.177,0l-.884.884a.126.126,0,0,0,0,.177l.486.486a.125.125,0,0,0,.177,0l.884-.885A.126.126,0,0,0,69.417,743.2Zm-7.166-.485a.125.125,0,0,0-.177,0l-.486.485a.127.127,0,0,0-.036.089.124.124,0,0,0,.036.088l.884.885a.125.125,0,0,0,.177,0l.486-.486a.125.125,0,0,0,0-.177Zm-.658,3.442h-1.25a.125.125,0,0,0-.125.125v.688a.125.125,0,0,0,.125.125h1.25a.125.125,0,0,0,.125-.125v-.688A.125.125,0,0,0,61.594,746.156Z",
    transform: "translate(-58.5 -739.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e42f5eb22526c615432cf0ecc961aa46.svg";
export { ForwardRef as ReactComponent };